<div class="d-flex align-items-center justify-content-center h-100">
  <wb-ui-loading-logo></wb-ui-loading-logo>
</div>
